import { handleRequest } from "../utilities/requestHandler";

export const verifyEmail = (otp,user_id) =>
    handleRequest("post","/auth/verify-email",{
        otp: otp,
        ...(typeof user_id === "object" && user_id !== null
            ? {
                flow_token: user_id.flowToken || user_id.flow_token,
                ...(user_id.user_id ? { user_id: user_id.user_id } : {}),
            }
            : {
                user_id: user_id,
            }),
    });

export const sendOTP = (userId, options = {}) =>
    handleRequest("post","/auth/send-otp",{
        ...(typeof userId === "object" && userId !== null
            ? {
                flow_token: userId.flowToken || userId.flow_token,
                ...(userId.user_id ? { user_id: userId.user_id } : {}),
            }
            : {
                user_id: userId,
            }),
        force_resend: Boolean(options?.forceResend),
    });
